/**
 * -----------------------------------------------------------------------------
 * Project  : ReelConsensus app - Frontend Service: auth
 * File     : auth.js
 * Author   : Zachary Dry
 * Created  : 2025-09-18
 * Updated  : 2025-09-19
 * Version  : 1.0
 * License: Proprietary (Company Confidential)
 * -----------------------------------------------------------------------------
 * Description:
 *   Client-side service for API access and side effects related to auth.
 *   Exports: clearToken, loadToken, saveToken
 *   
 *
 * Dependencies:
 *   - ./api
 *
 * Usage:
 *   Import service: import * as auth from '@/services/auth';
 * -----------------------------------------------------------------------------
 */
import { login as apiLogin, register as apiRegister, me as apiMe } from './api';
import { setAuthToken } from './api';

const TOKEN_KEY = 'token';

export function saveToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
  setAuthToken(token);
}

export function loadToken() {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) setAuthToken(t);
  return t;
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  setAuthToken(null);
}

export async function login(credentials) {
  const data = await apiLogin(credentials);
  saveToken(data.token);
  return data;
}

export async function register(credentials) {
  const data = await apiRegister(credentials);
  saveToken(data.token);
  return data;
}

export async function me() {
  return apiMe();
}


